import { IHallBookingBill } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	billNo: string
	date: number
	bookingId: string
	incomeId: string
	electricity: {
		previousReading: number
		currentReading: number
		amount: number
	}
	gas: {
		previousReading: number
		currentReading: number
		amount: number
	}
	items: {
		itemId: string
		quantity: number
		days: number
	}[]
}

export async function hallBookingBillAddApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/hall/booking/bill/add/v1"
	const requester = new ApiRequester<RequestDataShape, IHallBookingBill>(endpoint)
	return await requester.sendRequest(payload, token)
}
